import Text, { TEXT_VARIANT_STYLES } from "shared/components/data-display/text/Text";
import { COLOR_VALUES } from "shared/config/colors";
import styled from "styled-components";

export const EmailLink = styled.a`
    color: ${COLOR_VALUES.Blue_3};
    ${TEXT_VARIANT_STYLES.Body_2_1};
`;

export const StyledLinkText = styled(Text)`
    cursor:pointer;
    color: ${COLOR_VALUES.Blue_3};
    ${TEXT_VARIANT_STYLES.Body_2_1};
`;
